// src/sections/SearchModals.tsx
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes, FaGoogle, FaMicrosoft } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

export const LoginPromptModal: React.FC<{ isOpen: boolean; onClose: () => void; onSignInClick: () => void }> = ({ isOpen, onClose, onSignInClick }) => {
    const { t } = useTranslation();
    if (!isOpen) return null;
    return (
        <motion.div
            className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
        >
            <motion.div
                className="bg-white rounded-2xl shadow-xl max-w-md w-full relative p-8 text-center text-gray-800"
                initial={{ scale: 0.9, y: 50 }}
                animate={{ scale: 1, y: 0 }}
                exit={{ scale: 0.9, opacity: 0 }}
                transition={{ duration: 0.3 }}
                onClick={(e) => e.stopPropagation()}
            >
                <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-800">
                    <FaTimes size={20} />
                </button>
                <div className="flex flex-col items-center">
                    <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mb-4">
                        <FaTimes className="text-4xl text-red-500" />
                    </div>
                    <h2 className="text-2xl font-bold mb-2">
                        {t('not_logged_in_title')}
                    </h2>
                    <p className="text-gray-600 mb-6">
                        {t('login_required_description')}
                    </p>
                    <button
                        onClick={onSignInClick}
                        className="bg-[#1A237E] text-white py-3 px-8 rounded-full font-bold transition-all duration-300 hover:bg-blue-800"
                    >
                        {t('sign_in_button')}
                    </button>
                    <p className="text-sm text-gray-500 mt-4">
                        {t('trial_info')}
                    </p>
                </div>
            </motion.div>
        </motion.div>
    );
};